import React, { useState, useEffect } from "react";
import {
  Typography,
  Chip,
  Stack,
  Accordion,
  AccordionDetails,
  Button,
  Box,
} from "@mui/material";
import CustomAccordionSummary from "styles/customAccordionSummary";
import { ExpandMore } from "@mui/icons-material";
import {
  ALL,
  COVERAGE_CRITERIA_ALL,
  initialLobValues,
  validationOptions,
} from "../Constants/PolicyTranslationConstants";
import Chips from "components/Chips";
import { getLobNamesForFilter } from "../Utils/TranslationUtils";
import { useDispatch } from "react-redux";
import { setDialog } from "slices/appSlice";

/**
 * TranslationFilter
 * Shared between PolicyTranslation and UseCases
 */
function TranslationFilter({
  activeInactive,
  setActiveInactive,
  onAccordionToggle,
}) {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [lobListValues, setLobListValues] = useState(initialLobValues);
  const [coverageCriteria, setCoverageCriteria] = useState([]);

  const varianceValues = [
    { label: "All", selected: false, value: "All" },
    { label: "Variance", selected: false, value: "VARIANCE" },
  ];

  const useCaseValues = [
    { label: "All", selected: false, value: "All" },
    { label: "To Do", selected: false, value: "ToDo" },
    { label: "Complete", selected: false, value: "Complete" },
  ];

  const handleAccordionChange = () => {
    setExpanded((prev) => {
      const newExpanded = !prev;
      onAccordionToggle();
      return newExpanded;
    });
  };

  const handleResetFilters = () => {
    setActiveInactive("All");
  };

  const isResetVisible = activeInactive !== "All";

  return (
    <Accordion
      sx={{ padding: 0, margin: 0 }}
      expanded={expanded}
      onChange={handleAccordionChange}
    >
      <CustomAccordionSummary
        sx={{ padding: 0, margin: 0 }}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{ padding: 0, mb: 0 }}
          px={(theme) => theme.spacing(1)}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Quick Filters:
          </Typography>
          {isResetVisible && (
            <Button onClick={handleResetFilters} color={"chip"}>
              Reset
            </Button>
          )}
          {!expanded && activeInactive !== "All" && (
            <Typography variant="body2">
              <span style={{ fontWeight: "bold" }}>Active/Inactive:</span>{" "}
              {activeInactive}
            </Typography>
          )}
        </Stack>
      </CustomAccordionSummary>
      <AccordionDetails sx={{ padding: 0, mb: 1 }}>
        <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: "wrap" }}>
          <Typography
            variant="subtitle1"
            sx={{ minWidth: 170, fontWeight: "bold" }}
          >
            Active/Inactive:
          </Typography>
          <Chip
            sx={{ minWidth: 50 }}
            label="All"
            onClick={() => setActiveInactive("All")}
            color={activeInactive === "All" ? "selectedChip" : "chip"}
          />
          <Chip
            sx={{ minWidth: 50 }}
            label="Active"
            onClick={() => setActiveInactive("Active")}
            color={activeInactive === "Active" ? "selectedChip" : "chip"}
          />
          <Chip
            sx={{ minWidth: 50 }}
            label="Inactive"
            onClick={() => setActiveInactive("Inactive")}
            color={activeInactive === "Inactive" ? "selectedChip" : "chip"}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}

function ProcedureCodeDialogFilter({
  chips,
  handleFilterCodeList,
  dialogSelectedCC,
  selectedVarianceOption,
  setSelectedVarianceOption,
  handleFilterVarianceList,
  setDialogSelectedCC,
}) {
  const varianceValues = [
    { label: "All", selected: false, value: "All" },
    { label: "Variance", selected: false, value: ["NEW", "VARIANCE"] },
    { label: "No Variance", selected: false, value: "NOVARIANCE" },
  ];
  const handleCCFilterClick = (cc) => {
    setDialogSelectedCC(cc);
    handleFilterCodeList(cc);
  };
  const handleVarianceFilterClick = (v) => {
    if (Array.isArray(v)) {
      setSelectedVarianceOption(v[0]);
    } else {
      setSelectedVarianceOption(v);
    }
    handleFilterVarianceList(v);
  };
  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 0.5 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
        >
          By CC#
        </Typography>
        {[COVERAGE_CRITERIA_ALL, ...chips].map((cc) => (
          <Chip
            sx={{ minWidth: 50 }}
            key={cc}
            label={cc}
            onClick={() => handleCCFilterClick(cc)}
            color={dialogSelectedCC === cc ? "selectedChip" : "chip"}
          />
        ))}
      </Stack>
      <Stack
        direction="row"
        spacing={1}
        sx={{ flexWrap: "wrap", gap: 0.5, marginTop: 1 }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", whiteSpace: "nowrap", marginTop: "1px" }}
        >
          By Variance:
        </Typography>

        {varianceValues.map((v) => (
          <Chip
            sx={{ minWidth: 50 }}
            key={Array.isArray(v.value) ? v.value.join("-") : v.value}
            label={v.label}
            onClick={() => handleVarianceFilterClick(v.value)}
            color={
              Array.isArray(v.value)
                ? v.value.includes(selectedVarianceOption)
                  ? "selectedChip"
                  : "chip"
                : selectedVarianceOption === v.value
                  ? "selectedChip"
                  : "chip"
            }
          />
        ))}
      </Stack>
    </Box>
  );
}

export { TranslationFilter, ProcedureCodeDialogFilter };
